import React, { ChangeEvent, ReactElement } from 'react'

import { Spacing } from '../../enums/spacing'
import { useMultipleSelectableValues } from '../../hooks/useMultipleSelectableValues'
import { ComponentsGroupProps } from '../ComponentsGroup'
import { CheckboxGroupProvider } from './contexts/checkboxGroupContext'
import * as Styled from './styles'

export interface CheckboxGroupProps extends Pick<ComponentsGroupProps, 'children' | 'direction' | 'spacing'> {
  name?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onChangeMultiple?: (value: string[]) => void
  value?: string | string[]
  defaultValue?: string | string[]
  disabled?: boolean
}

export const CheckboxGroup = ({
  children,
  defaultValue,
  disabled,
  name,
  onChange,
  onChangeMultiple,
  spacing = Spacing.S8,
  value,
  ...props
}: CheckboxGroupProps): ReactElement => {
  const { checkedValue, groupName, handleComponentChange } = useMultipleSelectableValues({
    defaultValue,
    name,
    onChange,
    onChangeMultiple,
    value,
  })

  return (
    <CheckboxGroupProvider disabled={disabled} name={groupName} value={checkedValue} onChange={handleComponentChange}>
      <Styled.CheckboxGroupWrapper {...props} spacing={spacing}>
        {children}
      </Styled.CheckboxGroupWrapper>
    </CheckboxGroupProvider>
  )
}
